import { render, staticRenderFns } from "./exchangeTime.vue?vue&type=template&id=133f3c1a&scoped=true&"
import script from "./exchangeTime.vue?vue&type=script&lang=js&"
export * from "./exchangeTime.vue?vue&type=script&lang=js&"
import style0 from "./exchangeTime.vue?vue&type=style&index=0&id=133f3c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f3c1a",
  null
  
)

export default component.exports